import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import { INTEGRATION_KEY } from '../../state/integration/Constants';
import GlobalHelper from "../GlobalHelper";
import BankAccountContainer from "../bank-account/container.component.jsx";
import ExternalCheckoutContainer from "../external-checkout/externalcheckoutcontainer.component.jsx";
import Icon from "../icon/icon.component.jsx";
import LoadingSpinner from "../spinner/loading.component.jsx";
import CreditCardContainer from "./container.component.jsx";

const TestCard = {
    [INTEGRATION_KEY.STRIPE]: '4242 4242 4242 4242 - 12/32 - 123 - 10001',
    [INTEGRATION_KEY.SQUARE]: '4111 1111 1111 1111 - 12/32 - 111 - 11111',
    [INTEGRATION_KEY.SQUARE_PAYMENTS]: '4111 1111 1111 1111 - 12/32 - 111 - 11111'
}


class OnlinePayment extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            onSubmit: this.props.onSubmit || function () { },
            onClose: this.props.onClose || function () { },
            publicKey: this.props.publicKey || '',
            merchantId: this.props.merchantId || '',
            currency: this.props.currency || AppContext.getAccount().attributes.currency,
            amount: this.props.amount || '0',
            integrationKey: this.props.integrationKey || '',
            companyName: this.props.companyName || '',
            proposalHash: this.props.proposalHash || '',
            countryCode: this.props.countryCode,
            loading: false,
            submitButton: this.props.submitButton,
            submitDisabled: this.props.submitDisabled,
            submitButtonStyle: this.props.submitButtonStyle,
            forceSaveCard: this.props.forceSaveCard || false,
            forceSaveBankAccount: this.props.forceSaveBankAccount || false,
            paymentType: this.props.paymentType || 'credit-card',
            saveCard: true,
            testMode: this.props.testMode || false,
            onPaymentIntentCompleted: this.props.onPaymentIntentCompleted || function () { },
            contactId: this.props.contactId || '',
            saveAndChargeLater: this.props.saveAndChargeLater || false,
            ignoreAuthentication: this.props.ignoreAuthentication || false,
            myAccountBilling: this.props.myAccountBilling || false,
            locationId: this.props.locationId || '',
            acceptedCardBrands: this.props.acceptedCardBrands || [],
        }
        this.handleSubmitNewCard = this.handleSubmitNewCard.bind(this)
        this.handleSubmitNewBankAccount = this.handleSubmitNewBankAccount.bind(this)
    }

    handleSubmitNewCard(setupIntent, token, saveCard, error, next) {
        this.state.onSubmit(setupIntent, token, saveCard, error, next)
    }


    handleSubmitNewBankAccount(token, err, next) {
        this.state.onSubmit({
            token: token.token,
            last4: token.last4,
            bankAccountId: token.bankAccountId,
        }, err, next)
    }

    componentDidMount() {
        if (this.state.publicKey) {
            return
        }
        this.setState({
            loading: true,
        })
        this.reloadKeys()
    }

    isExternalCheckout() {
        return this.state.paymentType === 'external-checkout'
    }

    reloadKeys() {
        let hasOnlyOneAllPaymentIntegration = GlobalHelper.hasOnlyOneAllPaymentIntegration()
        if (!this.state.currency || this.state.myAccountBilling || this.isExternalCheckout() ||
            (!this.props.locationId && AppContext.locations.length > 0 && !hasOnlyOneAllPaymentIntegration)) {
            this.setState({
                loading: false,
            })
            return
        }
        let locationId = this.state.locationId
        if (!locationId && hasOnlyOneAllPaymentIntegration) {
            locationId = "none"
        }
        AppContext.getApiClient().get('/payment-integration-public-api-keys/' + this.state.currency + '/' + locationId).then(r => {
            this.setState({
                publicKey: r.attributes.publicApiKey,
                integrationKey: r.attributes.integrationKey,
                testMode: r.attributes.testMode,
                merchantId: r.attributes.merchantId,
                loading: false,
            })
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const currency = this.state.currency
        let state = {
            submitDisabled: nextProps.submitDisabled,
            currency: nextProps.currency || this.state.currency,
            amount: nextProps.amount,
            paymentType: nextProps.paymentType || 'credit-card',
        }
        if (nextProps.publicKey) {
            state.publicKey = nextProps.publicKey || this.state.publicKey
            state.testMode = nextProps.testMode
            state.integrationKey = nextProps.integrationKey || this.state.integrationKey
        }
        if (this.props.locationId !== nextProps.locationId && nextProps.locationId !== "") {
            this.setState({
                loading: true,
                locationId: nextProps.locationId,
            })
        }
        this.setState(state, () => {
            if (currency !== this.state.currency || this.state.loading) {
                this.reloadKeys()
            }
        })
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }
        if (!this.state.integrationKey || (!this.state.publicKey && !this.isExternalCheckout())) {
            return <div>
                <p className="text-danger">
                    <FormattedMessage
                        id="common.online_payment.location_error_msg"
                        defaultMessage="Location {name} doesn't have a payment integration setup at the moment."
                        values={{
                            name: GlobalHelper.getLocationById(this.state.locationId)?.attributes.name
                        }}
                    />
                </p>
            </div>
        }
        switch (this.state.paymentType) {
            case 'external-checkout':
                return <ExternalCheckoutContainer
                    integrationKey={this.state.integrationKey}
                    proposalHash={this.state.proposalHash}
                    submitDisabled={this.state.submitDisabled}
                    submitButton={this.state.submitButton}
                    submitButtonStyle={this.state.submitButtonStyle}
                    currency={this.state.currency}
                    amount={this.state.amount}
                    contactId={this.state.contactId}
                    variables={this.props.variables}
                    externalCheckoutPaymentType={this.props.externalCheckoutPaymentType}
                />

            case 'bank-transfer':
                return (
                    <BankAccountContainer
                        onSubmit={this.handleSubmitNewBankAccount}
                        onClose={this.state.onClose}
                        apiKey={this.state.publicKey}
                        countryCode={this.state.countryCode}
                        integrationKey={this.state.integrationKey}
                        proposalHash={this.state.proposalHash}
                        testMode={this.state.testMode}
                        forceSaveBankAccount={this.state.forceSaveBankAccount}
                        submitDisabled={this.state.submitDisabled}
                        submitButton={this.state.submitButton}
                        submitButtonStyle={this.state.submitButtonStyle}
                        currency={this.state.currency}
                        amount={this.state.amount}
                        companyName={this.state.companyName}
                        contactId={this.state.contactId}
                        paymentAccount={this.props.paymentAccount}
                        buildMetaData={this.props.buildMetaData}
                    >
                    </BankAccountContainer>
                )
            case 'credit-card':
            default:
                return (
                    <CreditCardContainer
                        onSubmit={this.handleSubmitNewCard}
                        onClose={this.state.onClose}
                        refreshContact={this.props.refreshContact}
                        apiKey={this.state.publicKey}
                        countryCode={this.state.countryCode}
                        integrationKey={this.state.integrationKey}
                        testMode={this.state.testMode}
                        submitDisabled={this.state.submitDisabled}
                        submitButton={this.state.submitButton}
                        submitButtonStyle={this.state.submitButtonStyle}
                        currency={this.state.currency}
                        amount={this.state.amount}
                        merchantId={this.state.merchantId}
                        onPaymentIntentCompleted={this.state.onPaymentIntentCompleted}
                        saveCard={this.state.saveCard}
                        forceSaveCard={this.state.forceSaveCard}
                        contactId={this.state.contactId}
                        saveAndChargeLater={this.state.saveAndChargeLater}
                        ignoreAuthentication={this.state.ignoreAuthentication}
                        buildMetaData={this.props.buildMetaData}
                        showSaveCardComponent={this.props.showSaveCardComponent}
                        proposalHash={this.props.proposalHash}
                        paymentAccount={this.props.paymentAccount}
                        isIntegrationConfigurationEnabled={this.props.isIntegrationConfigurationEnabled}
                        onCardAdded={this.props.onCardAdded}
                        locationId={this.props.locationId}
                        acceptedCardBrands={this.state.acceptedCardBrands}
                    >
                        {!this.state.forceSaveCard ? <div className={'row'}>
                            <div className={'col-12 pt-2'}>
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="customCheck1"
                                        checked={this.state.saveCard}
                                        onChange={e => {
                                            this.setState({
                                                saveCard: e.target.checked
                                            })
                                        }}
                                    />
                                    <label className="custom-control-label" htmlFor="customCheck1">
                                        <FormattedMessage
                                            id="common.credit_card.save_card_on_file_checkbox"
                                            defaultMessage="Save your card for future payments"
                                        />
                                    </label>
                                </div>
                            </div>
                        </div> : ''}
                        {this.state.testMode ? <div className={'row'}>
                            <div className={'col-12 pt-2'}>
                                <p className={'text-danger mb-0'}>
                                    <small>
                                        <Icon value={'info-circle'} className={'mr-1'} />
                                        <FormattedMessage
                                            id="common.credit_card.stripe.test_card"
                                            defaultMessage="You can use the following test card:"
                                        />
                                        <br />
                                        <strong className={'pl-4'}>
                                            {TestCard[this.state.integrationKey]}
                                        </strong>
                                    </small>
                                </p>
                            </div>
                        </div> : ''}
                    </CreditCardContainer>

                )
        }

    }
}

export default OnlinePayment





// WEBPACK FOOTER //
// ./src/common/credit-card/online-payment.component.jsx